import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Checkout", -1 /* HOISTED */)
const _hoisted_3 = { class: "row border-bottom text-muted" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 py-2 px-3" }, " Item ", -1 /* HOISTED */)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 py-2 px-3 text-right text-nowrap" }, " Qty ", -1 /* HOISTED */)
const _hoisted_6 = { class: "col-4 py-2 px-3 text-nowrap" }
const _hoisted_7 = {
  key: 0,
  style: {"float":"right"}
}
const _hoisted_8 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1 /* HOISTED */)
const _hoisted_10 = { class: "col-5 py-2 px-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("li", null, " Add-Ons", -1 /* HOISTED */)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { class: "col-2 py-2 px-3 text-right text-nowrap" }
const _hoisted_17 = {
  key: 0,
  class: "col-4 py-2 px-3 text-right text-nowrap"
}
const _hoisted_18 = {
  key: 1,
  class: "col py-2 px-3 text-left"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 28 28",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "row font-weight-bold border-top" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-5 py-2 px-3" }, " Total ", -1 /* HOISTED */)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-2 py-2 px-3 text-right text-nowrap" }, null, -1 /* HOISTED */)
const _hoisted_27 = {
  key: 0,
  class: "col-4 py-2 px-3 text-right text-nowrap"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1 /* HOISTED */)
const _hoisted_29 = { class: "mt-3 row" }
const _hoisted_30 = {
  key: 0,
  href: "",
  class: "text-primary text-muted"
}
const _hoisted_31 = {
  key: 1,
  href: "",
  class: "text-primary text-muted"
}
const _hoisted_32 = { class: "float-right" }
const _hoisted_33 = {
  key: 0,
  href: "",
  class: "text-primary",
  style: {"color":"green !important"}
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-1" }, null, -1 /* HOISTED */)
const _hoisted_35 = {
  key: 0,
  class: "btn btn-primary"
}
const _hoisted_36 = {
  key: 1,
  class: "btn btn-primary"
}
const _hoisted_37 = {
  key: 2,
  class: "btn btn-primary"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, " Process Downgrade ", -1 /* HOISTED */)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, " Pay via Credits ", -1 /* HOISTED */)
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = {
  key: 3,
  class: "mt-3"
}
const _hoisted_43 = ["href"]
const _hoisted_44 = {
  key: 1,
  class: "alert alert-warning mt-3"
}
const _hoisted_45 = {
  key: 2,
  class: "alert alert-warning mt-3",
  style: {"position":"relative"}
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("a", {
  href: "",
  class: "text-muted small"
}, " Cancel Downgrade ", -1 /* HOISTED */)
const _hoisted_47 = [
  _hoisted_46
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CancelSubscription = _resolveComponent("CancelSubscription")

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.cart_details.cart && $props.cart_details.cart.length && $props.pending_downgrades.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, [
                (!$options.is_downgrade || $options.auto_renewal)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, " Amount "))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, "Details"))
              ]),
              _hoisted_9
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.cart_details.cart, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: item.upgrade_type
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(item.upgrade_type) + " ", 1 /* TEXT */),
                  ($options.is_subscription(item) && item.has_addons)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createElementVNode("ul", null, [
                          _hoisted_12,
                          _createElementVNode("ul", null, [
                            (item.extra_users>0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_13, _toDisplayString(item.extra_users) + " Users @ " + _toDisplayString(item.extra_users_rate), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (item.extra_space>0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_14, _toDisplayString(item.extra_space) + " GB Space @ " + _toDisplayString(item.extra_space_rate), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true),
                            (item.extra_emails>0)
                              ? (_openBlock(), _createElementBlock("li", _hoisted_15, _toDisplayString(item.extra_emails) + " Emails @ " + _toDisplayString(item.extra_emails_rate), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(item.value), 1 /* TEXT */),
                (!$options.is_downgrade || $options.auto_renewal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.amt_to_display), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true),
                ($options.is_downgrade && !$options.auto_renewal)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createTextVNode(_toDisplayString(item.description) + " ", 1 /* TEXT */),
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(item.expiry), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createElementVNode("div", {
                  class: "col-1 d-flex justify-content-center align-items-center",
                  onClick: _withModifiers($event => (_ctx.$emit('remove_from_cart', item.upgrade_type)), ["prevent"])
                }, [
                  (!$options.is_subscription(item))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "text-muted",
                        href: "",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }, _hoisted_22))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23))
                ], 8 /* PROPS */, _hoisted_20)
              ]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              (!$options.is_downgrade || $options.auto_renewal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString($props.cart_details.total_to_display), 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _hoisted_28
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", {
              class: "col-6",
              onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('address')), ["prevent"]))
            }, [
              _createElementVNode("span", null, [
                ($props.address.address)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_30, "Change Billing Address"))
                  : (_openBlock(), _createElementBlock("a", _hoisted_31, "Set Billing Address"))
              ])
            ]),
            (!$props.legacy_plan && $props.site.subscription_status=='Trial' && !$options.is_downgrade)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "col-5 text-nowrap",
                  onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.$emit('switch_billing_cycle')), ["prevent"]))
                }, [
                  _createElementVNode("span", _hoisted_32, [
                    ($props.cart.billing_cycle=='Monthly')
                      ? (_openBlock(), _createElementBlock("a", _hoisted_33, _toDisplayString($options.setup_discount_offering()), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ])
                ]))
              : _createCommentVNode("v-if", true),
            _hoisted_34
          ]),
          ($options.show_pay_button)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "mt-3",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.$emit('pay')))
              }, [
                ($props.site.country === 'India')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_35, "Pay via Razorpay"))
                  : ($props.site.country === 'Indonesia')
                    ? (_openBlock(), _createElementBlock("button", _hoisted_36, "Pay via Midtrans"))
                    : (_openBlock(), _createElementBlock("button", _hoisted_37, "Pay via PayPal"))
              ]))
            : _createCommentVNode("v-if", true),
          ($options.is_downgrade)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "mt-3",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.$emit('process_downgrade')))
              }, _hoisted_39))
            : _createCommentVNode("v-if", true),
          ($options.show_pay_via_credit)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "mt-3",
                onClick: _cache[5] || (_cache[5] = $event => (_ctx.$emit('pay')))
              }, _hoisted_41))
            : _createCommentVNode("v-if", true),
          ($options.show_buy_credits)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("a", {
                  class: "btn btn-secondary",
                  href: $options.prm_url,
                  target: "_blank"
                }, " Buy Credits ", 8 /* PROPS */, _hoisted_43)
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    ($options.auto_renewal && !$options.plan_or_cycle_changed && !$options.is_addon_changed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
          _createTextVNode(" You card will be charged automatically every month "),
          _createVNode(_component_CancelSubscription, {
            cart_details: $props.cart_details,
            site: $props.site,
            email: $props.email
          }, null, 8 /* PROPS */, ["cart_details", "site", "email"])
        ]))
      : _createCommentVNode("v-if", true),
    ($props.pending_downgrades.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pending_downgrades, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.type
            }, " Downgrade is scheduled on " + _toDisplayString(item.scheduled_on) + " for " + _toDisplayString(item.type) + ": " + _toDisplayString(item.value), 1 /* TEXT */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("div", {
            class: "d-flex",
            style: {"position":"absolute","right":"1rem","top":"1rem","bottom":"1rem"},
            onClick: _cache[6] || (_cache[6] = _withModifiers($event => (_ctx.$emit('cancel_downgrade')), ["prevent"]))
          }, _hoisted_47)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}